import React, { useMemo, useState } from "react";
import { Checkbox } from "antd";
import { EditFareComponent } from "./edit-fare.component";
import { MultiDayFareCalendar } from "./multi-day-fare-calendar.component";
import { getAPIDateFormat } from "../../utils/date.utils";
import './search-edit-fare-block.style.scss';

export const SearchEditFareBlock = (props) => {
    const {
        item,
        onFareUpdateSuccess,
        onCancel
    } = props;

    const travelDate = item.trip.trip_start_date;
    const travelApiDate = useMemo(() => getAPIDateFormat(travelDate), [travelDate]);

    const [multiDayMode, setMultiDayMode] = useState(false);
    const [additionalDates, setAdditionalDates] = useState([]);

    const handleMultiDayToggle = (e) => {
        const checked = e.target.checked;
        setMultiDayMode(checked);
        if (!checked) {
            setAdditionalDates([]);
        }
    };

    const handleReset = () => setAdditionalDates([]);

    const selectedDates = useMemo(() => {
        if (!multiDayMode || additionalDates.length === 0) {
            return [travelApiDate];
        }
        return [travelApiDate, ...additionalDates];
    }, [multiDayMode, additionalDates, travelApiDate]);

    const renderAboveTable = () => (
        <div className="search-edit-fare-multi-day">
            <Checkbox checked={multiDayMode} onChange={handleMultiDayToggle}>
                Edit fare for multiple days
            </Checkbox>
            {multiDayMode && (
                <div className="search-edit-fare-calendar-wrapper">
                    <MultiDayFareCalendar
                        scheduleId={item.schedule_id}
                        travelDate={travelDate}
                        additionalDates={additionalDates}
                        onAdditionalDatesChange={setAdditionalDates}
                        onReset={handleReset}
                    />
                </div>
            )}
        </div>
    );

    return (
        <EditFareComponent
            scheduleDescription={item.description}
            travelDate={travelDate}
            selectedDates={selectedDates}
            scheduleId={item.schedule_id}
            seatGroupIds={item.bus.seat_group_ids}
            selectedBus={item.bus}
            onFareUpdateSuccess={onFareUpdateSuccess}
            supportedFare={item.bus.supported_fare}
            tripDynamicPricing={item.dynamic_pricing}
            onCancel={onCancel}
            clientSideCheck={true}
            renderAboveTable={renderAboveTable}
        />
    );
};
